import { MOKA_MATCH_EVEN_WIN_PROBABILITY } from "@/constants";
import { createMokaGameState } from "@/lib/moka-go-engine";
const getMokaMatchInitialPosition = gameMessage => ({
  blackWinProbability: MOKA_MATCH_EVEN_WIN_PROBABILITY,
  gameMessage,
  gameState: createMokaGameState(),
  humanMovePolicyPercentileCount: 0,
  humanMovePolicyPercentileSum: 0,
  isGameComplete: false,
  mokaResponseDurationMs: null,
  stones: []
});
export { getMokaMatchInitialPosition };